/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/ajax-warenkorb/shop.ajax-warenkorb.component.ts.
 */
import {ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {Warenkorb} from '../../../../models/warenkorb';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {WarenkorbKategorie} from '../../../../models/warenkorb-kategorie';

/**
 * Zweck: Beschreibt class ShopAjaxWarenkorbComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ajax-warenkorb',
    templateUrl: 'shop.ajax-warenkorb.component.html',
    styleUrls: ['shop.ajax-warenkorb.component.scss'],
    standalone: false
})
export class ShopAjaxWarenkorbComponent implements OnInit, OnDestroy {
  static id = 'ShopAjaxWarenkorbComponent';
  @Output() drawer_show = new EventEmitter();
  @Output() drawer_close = new EventEmitter();

  wkid: number;
  warenkorb = new BehaviorSubject<Warenkorb>(null);
  positions = new BehaviorSubject<WarenkorbEntry[]>([]);
  kategorien = new BehaviorSubject<WarenkorbKategorie[]>([]);

  loading = new BehaviorSubject<boolean>(true);


  label_map = {};

  wksub: Subscription;

  update_timeout: any;
  note_autosave_timeout: any;
  poscount: number;

  wkkref: any;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public svc: AppWarenkorbService) {
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load(silent = false) {
    if (!silent) {
      this.loading.next(true);
    }
    this.svc.getWarenkorbById(this.wkid).subscribe({
      next: (wk) => {
        this.warenkorb.next(wk);
        if (!silent) {
          this.loading.next(false);
        }
        this.drawer_show.emit();
      },
      error: (e) => {
        if (e.error && e.error.code == 10005) {
          this.svc.load();
        }
        this.loading.next(false);
      }
    });
  }


/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    if (this.wksub instanceof Subscription) {
      this.wksub.unsubscribe();
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.wksub = this.svc.primary_warenkorb$.subscribe(w => {
      if (w) {
        this.wkid = w.id;
        this.load();
      }
    });
  }

}
